import axios from "axios";
import { authProvider } from "./authProvider";

axios.interceptors.request.use(
  async (config) => {
    const accessTokenResponse = await authProvider.getAccessToken();
    config.headers.Authorization = `Bearer ${accessTokenResponse.accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.error(
        `[Network Error] Failed to reach ${error.config?.url}\n` +
        `Status: ${error.request?.status} — No response received (request blocked at network level, likely firewall/private endpoint).`
      );
    } else {
      console.error(
        `[API Error] ${error.config?.method?.toUpperCase()} ${error.config?.url} → ${error.response?.status} ${error.response?.statusText}`,
        error.response?.data
      );
    }
    return Promise.reject(error);
  }
);
